<ng-template #purchasedetails let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Purchase Information</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row" *ngIf="purchase_item">
			<div [ngClass]="purchase_item.purchdata.length == 1 ? 'col-md-12': 'col-md-6'" *ngFor="let pdata of purchase_item.purchdata">
				<div class="card highlight" (click)="setPurchOrderOptions(purchase_item, pdata)" [ngClass]="(pdata.supplierid == purchase_item.selected_option.supplierno) ? 'highlighted' : '' ">
					<div class="card-header text-center">
						<h4 class="card-title text-center">{{ pdata.supplierid }} - {{ pdata.suppname }} <b>{{ pdata.price | currency }}</b></h4>
					</div>
					<div class="card-body text-center">
						<div class="col-12">
							<h5>{{ pdata.stockid }}
								<div [innerHTML]="pdata.supplierdescription"></div>
							</h5>
						</div>
						<div class="col-12 p-0 m-0">
							<ul class="entry-list p-0 m-0" *ngFor="let remote of pdata.remote">
								<li>
									<div class="spec-label">{{ remote.feedlabel }}:</div>
									<div class="spec-value">{{ remote.qty }}</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #itemhistoryele let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Item Sales History {{ item?.item?.stockid || item?.stockid || purchitem?.stockid }} {{ purchitem?.indexmonth }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="text-center" *ngIf="itemhistory">
			<p class="text-muted small mb-3">Use the metrics below to decide how much to reorder. Compare <strong>Avail</strong> to <strong>Period Target</strong> and use the <strong>Seasonal Index</strong> by month to plan for higher- or lower-demand periods.</p>
			<p class="text-left" *ngIf="item.descriptions.description" [innerHTML]="item.descriptions.description"> </p>
			<p class="text-left" *ngIf="item.descriptions.benefits" [innerHTML]="item.descriptions.benefits"></p>

			<div class="row smaller-font">
				<div class="col-md-3 ml-0 mr-0 pl-0 pr-0" [ngClass]="purchitem.remote_inventory ? 'col-md-3' : 'col-md-3'">
					<ul class="entry-list p-0 m-0 bold">
						<li>
							<div class="spec-label" matTooltip="Quantity sold in the report period">Prd Sales:</div>
							<div class="spec-value">{{ purchitem.period_sales | number:'1.0-0' }}</div>
						</li>
						<li>
							<div class="spec-label" matTooltip="Target quantity for the period">Target:</div>
							<div class="spec-value">{{ purchitem.target | number:'1.0-0' }}</div>
						</li>
						<li>
							<div class="spec-label" matTooltip="Average daily sales rate (units per day)">Avg Sales:</div>
							<div class="spec-value">{{ purchitem.weekly_sales_amt | number:'1.2-2' }}</div>
						</li>
					</ul>
				</div>
				<div class="col-md-3 ml-0 mr-0 pl-0 pr-0">
					<ul class="entry-list p-0 m-0 bold">
						<li>
							<div class="spec-label" matTooltip="Quantity on hand">QOH:</div>
							<div class="spec-value">{{ purchitem.qoh | number:'1.0-0' }}</div>
						</li>
						<li>
							<div class="spec-label" matTooltip="Quantity committed (back order)">Back Order:</div>
							<div class="spec-value">{{ purchitem.qos | number:'1.0-0' }}</div>
						</li>
						<li>
							<div class="spec-label" matTooltip="Quantity on order from vendor">On Order:</div>
							<div class="spec-value">{{ purchitem.qop | number:'1.0-0' }}</div>
						</li>
					</ul>
				</div>
				<div class="col-md-3 ml-0 mr-0 pl-0 pr-0">
					<ul class="entry-list p-0 m-0 bold">
						<li>
							<div class="spec-label" matTooltip="Available to sell: QOH + On Order − Back Order">Avail:</div>
							<div class="spec-value">{{ (purchitem.qoh + purchitem.qop) - purchitem.qos | number:'1.0-0' }}</div>
						</li>
						<li>
							<div class="spec-label" matTooltip="Net average demand (seasonally adjusted)">Net Avg:</div>
							<div class="spec-value">{{ purchitem.seasonaldetails?.grandaverage | number:'1.0-0' }}</div>
						</li>
						<li>
							<div class="spec-label" matTooltip="Net total over the period">Net Total:</div>
							<div class="spec-value">{{ purchitem.seasonaldetails?.grandtotal | number:'1.0-0' }}</div>
						</li>
					</ul>
				</div>
				<div class="col-md-3 ml-0 mr-0 pl-0 pr-0">
					<ul class="entry-list p-0 m-0 bold">
						<li>
							<div class="spec-label" matTooltip="Recommended order quantity to cover the period">Period Target:</div>
							<div class="spec-value">{{ purchitem.qty_purchase | number:'1.0-0' }}</div>
						</li>
					</ul>
				</div>


				<div class="col-md-4 ml-0 mr-0 pl-0 pr-0 d-none">
					<div class="row m-0 p-0">
						<div class="col-12" *ngIf="purchitem.remote_inventory">
							<ul class="entry-list p-0 m-0 bold" *ngFor="let remote of purchitem.remote_inventory">
								<li>
									<div class="spec-label">{{ remote.feedlabel }}:</div>
									<div class="spec-value">{{ remote.qty }}</div>
								</li>
							</ul>
						</div>
						<div class="col-md-12" *ngIf="!item.remote_inventory">
							<ul class="entry-list p-0 m-0 bold">
								<li>
									<div class="spec-label">n/a:</div>
									<div class="spec-value">n/a</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<p class="text-muted small mt-2 mb-1" *ngIf="purchitem?.seasonals?.length">Table: monthly <strong>Qty</strong> sold, <strong>Sales</strong> and <strong>Cost</strong>, and <strong>Seasonal Index</strong> (1.0 = average demand; &gt;1 = above average; &lt;1 = below average for that month).</p>
			<table class="table table-sm smaller-font" *ngFor="let year of itemhistory.years; let first = first">
				<tr>
					<th></th>
					<th *ngFor="let month of year.sales" [ngClass]="{'highlighted-solid': futuremonths.indexOf(month.label)>= 0,
							'highlighted-prev': months.indexOf(month.label) >= 0}">
						{{ month.label }} {{ month.year }}
					</th>
				</tr>
				<tr>
					<td class="text-left" matTooltip="Units sold this month">Qty</td>
					<td class="text-right" *ngFor="let month of year.qty" [ngClass]="{'highlighted-solid': futuremonths.indexOf(month.label)>= 0,'highlighted-prev': months.indexOf(month.label) >= 0}">
						{{ month.value | number:'1.0-0' }}
					</td>
				</tr>
				<tr>
					<td class="text-left" matTooltip="Sales revenue">Sales</td>
					<td class="text-right" *ngFor="let month of year.sales" [ngClass]="{'highlighted-solid': futuremonths.indexOf(month.label) >= 0,'highlighted-prev': months.indexOf(month.label) >= 0}">
						{{ month.value | currency }}
					</td>
				</tr>
				<tr>
					<td class="text-left" matTooltip="Cost of goods">Cost</td>
					<td class="text-right" *ngFor="let month of year.cost" [ngClass]="{'highlighted-solid': futuremonths?.indexOf(month.label)>= 0,'highlighted-prev': months.indexOf(month.label) >= 0}">
						{{ month.value | currency }}
					</td>
				</tr>
				<tr *ngIf="purchitem?.seasonals?.length">
					<td class="text-left" matTooltip="Seasonal index: relative demand for this month (1.0 = average). Use to adjust reorder quantities by month.">Seasonal Index</td>
					<td class="text-right" *ngFor="let month of purchitem.seasonals" [ngClass]="{'highlighted-solid': futuremonths.indexOf(month.label)>= 0,'highlighted-prev': months.indexOf(month.label) >= 0}">
						{{ month.index | number:'1.0-2' }}
					</td>
				</tr>
				<tr *ngIf="first && !purchitem?.seasonals?.length && purchitem">
					<td class="text-left text-muted" [attr.colspan]="(year?.sales?.length || 12) + 1">Seasonal index not available for this item.</td>
				</tr>
			</table>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<div class="daily-churn-form-shell daily-churn-form-shell--compact" *ngIf="reportForm">
	<form [formGroup]="reportForm" (ngSubmit)="getRecomendations()">
		<div *ngIf="formSubmitAttempted && reportForm?.invalid && getRequiredErrors().length" class="alert alert-warning daily-churn-alert py-2 px-3 mb-2" role="alert">
			<strong>Required:</strong> {{ getRequiredErrors().join(', ') }}
		</div>

		<div class="daily-churn-toolbar">
			<mat-form-field appearance="outline" class="daily-churn-tb-field daily-churn-tb-wh">
				<mat-label>Warehouse</mat-label>
				<mat-select formControlName="loccode">
					<mat-option *ngFor="let loc of locations" [value]="loc.loccode">{{ loc.locationname }}</mat-option>
				</mat-select>
				<mat-error *ngIf="reportForm.get('loccode')?.invalid && reportForm.get('loccode')?.touched">Required</mat-error>
			</mat-form-field>

			<div class="daily-churn-tb-vendor">
				<span class="daily-churn-tb-vendor-label">Vendor <span class="text-danger">*</span></span>
				<app-vendor-auto-complete class="daily-churn-vendor" (vendor_selected)="updateBrands($event)"></app-vendor-auto-complete>
				<small class="text-danger d-block" *ngIf="reportForm.get('supplier')?.invalid && reportForm.get('supplier')?.touched">Vendor required</small>
			</div>

			<mat-form-field appearance="outline" class="daily-churn-tb-field daily-churn-tb-date">
				<mat-label>From</mat-label>
				<input matInput [matDatepicker]="orderdatepicker" formControlName="startdate" (dateInput)="dateChanged()" (dateChange)="dateChanged()">
				<mat-datepicker-toggle matSuffix [for]="orderdatepicker"></mat-datepicker-toggle>
				<mat-datepicker #orderdatepicker></mat-datepicker>
				<mat-error *ngIf="reportForm.get('startdate')?.invalid && reportForm.get('startdate')?.touched">Required</mat-error>
			</mat-form-field>

			<mat-form-field appearance="outline" class="daily-churn-tb-field daily-churn-tb-date">
				<mat-label>To</mat-label>
				<input matInput [matDatepicker]="orderdatepickertwo" formControlName="enddate" (dateInput)="dateChanged()" (dateChange)="dateChanged()">
				<mat-datepicker-toggle matSuffix [for]="orderdatepickertwo"></mat-datepicker-toggle>
				<mat-datepicker #orderdatepickertwo></mat-datepicker>
				<mat-error *ngIf="reportForm.get('enddate')?.invalid && reportForm.get('enddate')?.touched">Required</mat-error>
			</mat-form-field>

			<span class="daily-churn-tb-days" role="status" matTooltip="Days in selected sales period">{{ numberofdays | abs }}d</span>

			<div class="daily-churn-tb-actions">
				<button mat-flat-button color="primary" type="submit">Run</button>
				<button mat-stroked-button type="button" color="accent" (click)="exportXls()" *ngIf="po_vendors_found">
					<i class="fa fa-file-excel-o mr-1" aria-hidden="true"></i>Excel
				</button>
			</div>
		</div>

		<details class="daily-churn-details">
			<summary class="daily-churn-details-summary">More filters &amp; options</summary>
			<div class="daily-churn-details-body">
				<div class="row">
					<div class="col-12 col-md-6 col-lg-4 mb-2">
						<mat-form-field appearance="outline" class="daily-churn-field w-100">
							<mat-label>Brands</mat-label>
							<mat-select multiple formControlName="brands" (selectionChange)="updateProductLines()" appSelectAll>
								<mat-option *ngFor="let opt of brands" [value]="opt.name">{{ opt.name }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mb-2">
						<mat-form-field appearance="outline" class="daily-churn-field w-100">
							<mat-label>Product lines</mat-label>
							<mat-select multiple formControlName="lines" appSelectAll>
								<mat-option *ngFor="let opt of product_lines" [value]="opt.line_field">{{ opt.line_field }} — {{ opt.line_description }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mb-2" *ngIf="config.env.package === 'tires'">
						<mat-form-field appearance="outline" class="daily-churn-field w-100">
							<mat-label>Winter</mat-label>
							<mat-select multiple formControlName="season" appSelectAll>
								<mat-option *ngFor="let opt of winter_values" [value]="opt.value">{{ opt.label }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-6 col-md-4 col-lg-2 mb-2">
						<mat-form-field appearance="outline" class="daily-churn-field w-100">
							<mat-label>Min orders</mat-label>
							<input matInput formControlName="minimum_sales">
						</mat-form-field>
					</div>
					<div class="col-6 col-md-4 col-lg-2 mb-2">
						<mat-form-field appearance="outline" class="daily-churn-field w-100">
							<mat-label>Day supply</mat-label>
							<input matInput formControlName="days_supply" (input)="updateTargets($event.target.value)">
						</mat-form-field>
					</div>
				</div>
				<div class="row align-items-start">
					<div class="col-12 col-lg-8 mb-0">
						<mat-form-field appearance="outline" class="daily-churn-field w-100">
							<mat-label>SKU list (optional)</mat-label>
							<textarea matInput formControlName="sku_list_text" rows="2" placeholder="Paste or CSV (first column); limits report to these SKUs"></textarea>
						</mat-form-field>
					</div>
					<div class="col-12 col-lg-4 daily-churn-sku-actions mb-0">
						<input type="file" accept=".csv,.txt,text/csv" (change)="onSkuCsvFile($event)" class="d-none" #skuCsvFile>
						<button type="button" mat-stroked-button (click)="skuCsvFile.click()"><i class="fa fa-upload mr-1" aria-hidden="true"></i>Import</button>
						<button type="button" mat-button (click)="clearSkuList()" *ngIf="reportForm.get('sku_list_text')?.value">Clear</button>
					</div>
				</div>
			</div>
		</details>
	</form>
</div>

<div class="row m-0 p-0">
	<div class="col-md-12">
		<div class="daily-churn-loading text-center py-4" *ngIf="loading">
			<svg class="spinner" width="48" height="48" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
				<circle class="path" fill="none" stroke-width="5" stroke-linecap="round" cx="33" cy="33" r="28"></circle>
			</svg>
			<p class="text-muted small mb-0 mt-2">Loading report…</p>
		</div>
		<ng-container *ngIf="!loading">
			<div *ngIf="lastCreatedPos.length" class="alert alert-success alert-dismissible fade show mb-3" role="alert">
				<strong>Success.</strong> {{ lastCreatedPos.length === 1 ? 'PO #' + lastCreatedPos[0].orderno + ' created.' : lastCreatedPos.length + ' POs created.' }}
				<a *ngIf="lastCreatedPos.length" [routerLink]="['/purchasing', lastCreatedPos[0].supplierno, lastCreatedPos[0].orderno]" class="alert-link ml-2">View PO</a>
				<a routerLink="/purchasing/openorders" class="alert-link ml-2">Open orders</a>
				<button type="button" class="btn-close" aria-label="Close" (click)="dismissPoSuccess()"></button>
			</div>
			<div *ngIf="poCreateError" class="alert alert-danger alert-dismissible fade show mb-3" role="alert">
				<strong>PO failed.</strong> {{ poCreateError }}
				<button type="button" class="btn-close" aria-label="Close" (click)="dismissPoError()"></button>
			</div>
			<ng-container *ngIf="!results && po_vendors_found">
				<h4 class="mt-3">No Results</h4>
			</ng-container>
			<ng-container *ngIf="results">

				<mat-tab-group (selectedTabChange)="onReorderMainTabChange($event)">
					<mat-tab label="Details">

						<ng-container *ngIf="po_vendors_found && po_vendors_found.length">
							<div class="table wrapper" *ngFor="let vendor of po_vendors_found" #exportTable>
								<!-- <h4>Filters: {{ reportForm | json }}</h4> -->
								<table class="table table-fixed table-hover table-bordered sticky-header">
									<thead>
										<tr>
											<th>Brand</th>
											<th>ProductLine</th>
											<th class="td-item">Item#</th>
											<th class="td-max">Description</th>
											<th class="text-center">QOH</th>
											<th class="text-center">QOS</th>
											<th class="text-center">QOO</th>
											<th class="text-center" *ngFor="let rol of rolling_months">
												{{rol.month}} {{rol.year}}
											</th>
											<th class="text-center">Total Period Sales</th>
											<th class="text-center" matTooltip="Days with no sales">Days Closed</th>
											<th class="text-center" matTooltip="Days with no stock and open">No Stock Days</th>
											<th class="text-center" matTooltip="Totals Days Open and With Stock">Sellable Days</th>
											<th class="text-center">Day Supply</th>
											<th class="text-center">Daily Turn</th>
											<!-- <th class="text-center">Price</th> -->
											<th class="text-center">Purchase</th>

										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let item of results[vendor]">
											<td><b>{{ item.brand_data.brand }}</b></td>
											<td>{{ item.brand_data.lineid }}-{{item.brand_data.linedesc}}</td>
											<td class="td-item"><a (click)="getItemHistory(item)">{{ item.stockid }}</a></td>
											<td [innerHTML]="item.description "></td>
											<td class="text-center">{{ item.qoh }}</td>
											<td class="text-center">{{ item.qos }}</td>
											<td class="text-center">{{ item.qop }}</td>
											<td class="text-center" *ngFor="let rol of item.rolling_year">
												{{rol.value}}
											</td>
											<td class="text-center border-left border-right">{{ item.rolling_total }}</td>
											<td class="text-center border-left border-right">{{ item.nosales }}</td>
											<td class="text-center">{{ item.outofstock }}</td>
											<td class="text-center">{{ item.day_c }}</td>

											<td class="text-center">{{ item.days_supply | number:'1.0-2' }}</td>
											<td class="text-center">{{ item.avg_day | number:'1.0-2'}}</td>
											<!-- <td class="text-center">{{ item.selected_option.price | currency}}</td> -->
											<td class="text-center">{{ item.target_avg_day | number:'1.0-0'}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</ng-container>
					</mat-tab>
					<mat-tab label="Results">
						<div class="table mt-2" *ngIf="po_vendors_found && po_vendors_found.length">
							<div class="container-fluid tp-box" [@flipState]="flip">
								<div class="row tp-box__side tp-box__front no-overflow">
									<mat-stepper #stepper (selectedIndex)="currentstep" class="w-100">
										<mat-step errorMessage="Review Results">

											<ng-template matStepLabel>{{ reviewlabel }}</ng-template>

											<div class="row mt-3 mb-3 no-overflow">

												<div class="col-12 text-right">
													<button mat-raised-button color="accent" matStepperNext>Next</button>
												</div>

												<div class="col-12 mt-3">
													<div class="table" *ngFor="let vendor of po_vendors_found">
														<h4 class="card-title text-left mt-3">{{ vendor }}</h4>
														<div class="wrapper">
															<table class="table table-fixed w-100">
																<thead>
																	<tr>
																		<th class="header"></th>
																		<th class="header">Vendor</th>
																		<th class="header">Item</th>

																		<th class="header text-center">YTD Qty Sales</th>
																		<th class="header">QOH</th>
																		<th class="header text-center">Committed</th>
																		<th class="header text-center">OnOrder</th>
																		<th class="header text-center">Avail</th>
																		<th class="header">MIN</th>
																		<th class="header">MAX</th>
																		<th class="header text-right">Remote Avail</th>
																		<th class="header text-right">Price</th>
																		<th class="header text-right">Order</th>
																		<th class="header text-right">Qty</th>
																	</tr>
																</thead>
																<tbody>
																	<ng-container *ngFor="let item of results[vendor]">
																	<tr *ngIf="showInPurchaseReview(item)">
																		<td>
																			<button class="mb-0 pt-0 pb-0 " mat-icon-button color="accent" (click)="removeItem(item,vendor)">
																				<mat-icon>remove</mat-icon>
																			</button>

																			<button class="mb-0 pt-0 pb-0 " mat-icon-button color="warn" (click)="viewPurchData(item)">
																				<mat-icon>settings</mat-icon>
																			</button>
																		</td>
																		<td>{{ item.vendor }}</td>
																		<!--<td (click)="getItemHistory(item)"> {{ item.stockid }}</td>-->
																		<td><a (click)="getItemHistory(item)"><b>{{ item.brand_data.brand }}</b><br>{{ item.stockid }}</a><br />
																			{{ item.description }}
																		</td>

																		<td class="text-center">{{ item.itemhistory.totals.thisyear_total_qty | number:'1.0-0' }}</td>
																		<td class="text-center">{{ item.qoh }}</td>
																		<td class="text-center">{{ item.qos }}</td>
																		<td class="text-center">{{ item.qop }}</td>
																		<td class="text-center">{{ ( item.qoh + item.qop ) - item.qos }}</td>

																		<td class="text-center">{{ item.minimum }}</td>
																		<td class="text-center">{{ item.maximum }}</td>
																		<td class="text-center">{{ item.total_available }}</td>
																		<td class="text-right">
																			{{ item.selected_option.price | currency }}
																			<!-- <input matInput type="text" placeholder="Price" [(value)]="item.selected_option.price" (input)="updatePrice($event.target.value, item)"> -->
																		</td>
																		<td class="text-right">{{ item.target_purchase }}</td>
																		<td class="text-right bolder" [ngClass]="{'bg-danger text-white bolder': item.total_available == 0 , 'bg-warning text-dark bolder': item.target_purchase > item.total_available && item.total_available > 0 }">
																			<input matInput type="number" class="form-control" placeholder="Purchase Qty" [(value)]="item.qty_purchase" (input)="updateQuantity($event.target.value, item)">
																		</td>
																	</tr>
																	</ng-container>
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>
										</mat-step>
										<mat-step errorMessage="Verify Fillable">
											<ng-template matStepLabel>Verify Purchase Order(s)</ng-template>
											<table class="table table-sm w-100">
												<div class="col-12 text-right" *ngIf="results.length">

													<button mat-raised-button color="warn" matStepperNext>Next</button>
												</div>
												<ng-container *ngFor="let vendor of po_vendors_found">
													<div class="col-12 m-0 p-0 mb-2 mt-2" *ngIf="results[vendor]">
														<ng-container *ngIf="results[vendor][0] && results[vendor][0].export_template">
															<button mat-raised-button color="primary" (click)="exportTemplate()" *ngIf="this.config.env.package == 'tires' && results[vendor][0].export_template ">
																<i class="fa fa-file-excel-o"></i>&nbsp;&nbsp;TREADNET</button>&nbsp;&nbsp;&nbsp;
														</ng-container>
													</div>

													<div class="card mt-2" class="col-md-12">
														<!-- *ngIf="vendorHasFillable(vendor)" -->
														<div class="row p-0 m-0">

															<div class="col-md-6">
																<button mat-raised-button color="accent" matStepperPrevious>Previous</button>
															</div>
															<div class="col-md-6 text-right">
																<ng-container *ngIf="!sending">
																	<button mat-raised-button color="warn" (click)="printResults(vendor)">
																		<i class="fa fa-file-pdf-o"></i> &nbsp;Print PO Preview</button>
																	&nbsp;&nbsp;
																	<button mat-raised-button aria-label="Change Vendor" color="accent" (click)="submitPo(vendor)" class="mt-2">
																		Next
																	</button>
																</ng-container>
																<ng-container *ngIf="sending">
																	<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
																		<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
																		</circle>
																	</svg>
																</ng-container>
															</div>
														</div>
														<div class="col-md-12">
															<h4 class="card-title text-left mt-3"><b>{{ vendor }}</b></h4>
														</div>
														<div class="row p-0 m-0" *ngIf="!vendorHasFillable(vendor)">
															<div class="col-6">
																<h4>No Items To Order</h4>
															</div>
														</div>
														<div class="card-body">
															<div class="row " *ngFor="let line of results[vendor]">
																<ng-container *ngIf="parsePurchaseQty(line.qty_purchase) > 0 && showInPurchaseReview(line)">
																	<div class="col-md-12 border-top text-left">
																		<div class="row">
																			<div class="col-md-1 p-0" [ngClass]="{'bg-danger text-white bolder': line.total_available == 0 , 'bg-warning text-dark bolder': line.target_purchase > line.total_available && line.total_available > 0 }">
																				<button mat-icon-button aria-label="Change Vendor" color="primary" (click)="viewPurchData(line)">
																					<mat-icon class="mt-2 smaller-font">edit</mat-icon>
																				</button>
																				<button class="mb-0 pt-0 pb-0 " mat-icon-button color="accent" (click)="removeItem(line,vendor)">
																					<mat-icon>remove</mat-icon>
																				</button>
																			</div>
																			<div class="col-md-3 mt-2 p-0">
																				<b>{{ line.brand_data.brand }}</b><br />
																				{{ line.stockid }}<br />
																				{{ line.description }}
																			</div>
																			<div class="col-md-3">
																				<ng-container>
																					<div class="col-md-12 p-0">
																						<ul class="entry-list p-0 m-0 bold">
																							<li>
																								<div class="spec-label">QOH</div>
																								<div class="spec-value">{{ line.qoh }}</div>
																							</li>
																						</ul>
																					</div>
																				</ng-container>
																				<ng-container *ngIf="line.selected_option">
																					<div class="col-md-12 p-0" *ngFor="let remote of line.selected_option.remote">
																						<ul class="entry-list p-0 m-0 bold">
																							<li>
																								<div class="spec-label">{{ remote.feedlabel }}:</div>
																								<div class="spec-value">{{ remote.qty }}</div>
																							</li>
																						</ul>
																					</div>
																				</ng-container>
																			</div>
																			<div class="col-md-2">
																				<mat-form-field appearance="outline">
																					<mat-label>Qty</mat-label>
																					<span matPrefix>#</span>
																					<input matInput type="number" value="{{ line.qty_purchase | number }}" (input)="updateQuantity($event.target.value, line )" class="text-right form-control">
																					<span matSuffix>/ {{ line.target_purchase }}</span>
																				</mat-form-field>
																			</div>
																			<div class="col-md-2">
																				<mat-form-field appearance="outline" class="">
																					<mat-label>
																						Price
																					</mat-label>
																					<span matPrefix>$</span>
																					<input matInput (input)="updatePrice($event.target.value, line )" value="{{ line.selected_option.price | number:'1.2-2' }}" class="text-right form-control">
																				</mat-form-field>
																			</div>
																			<div class="col-md-1 mt-4">
																				<mat-label>
																					Total
																				</mat-label>
																				<b>{{ line.selected_option.price * line.qty_purchase | currency }}</b>
																			</div>
																		</div>
																	</div>
																</ng-container>
															</div>
														</div>
													</div>
												</ng-container>
											</table>
										</mat-step>
									</mat-stepper>
								</div>
							</div>
						</div>

					</mat-tab>
					<mat-tab label="RMA review">
						<p class="text-muted small mt-3 mb-2">
							Lines with <strong>negative</strong> recommended purchase qty were removed from PO review when you chose to handle them as returns.
							Process vendor returns from <a routerLink="/purchasing/openorders">open purchase orders</a> using <strong>RGA / return</strong> on the relevant PO, or your existing RMA workflow.
						</p>
						<ng-container *ngIf="!rmaReviewVendorKeys.length">
							<p class="mt-2">No lines are in RMA review for this run.</p>
						</ng-container>
						<ng-container *ngFor="let rmaVendor of rmaReviewVendorKeys">
							<h4 class="mt-3">{{ rmaVendor }}</h4>
							<div class="table-responsive wrapper">
								<table class="table table-bordered table-sm">
									<thead>
										<tr>
											<th>Brand</th>
											<th>Item#</th>
											<th>Description</th>
											<th class="text-right">Suggested return qty</th>
											<th class="text-right">Original recommendation</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let r of rmaReviewByVendor[rmaVendor]">
											<td><b>{{ r.brand_data?.brand }}</b></td>
											<td>{{ r.stockid }}</td>
											<td>{{ r.description }}</td>
											<td class="text-right">{{ r.rma_return_qty | number:'1.0-0' }}</td>
											<td class="text-right">{{ r.original_recommendation | number:'1.0-0' }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</ng-container>
					</mat-tab>
					<mat-tab label="Un-fillable Items">
						<h4 *ngIf="!watch_items.length" class="mt-3">No Un-fillable Items Found</h4>
						<ng-container *ngIf="watch_items.length">
							<div class="row p-0 m-0">
								<div class="col-12 text-right mt-2 mb-2">
									<button mat-raised-button aria-label="Discontinue Items" color="primary" (click)="discontinueItems()">
										Discontinue Items
									</button>
								</div>
							</div>
							<div class="wrapper">
								<table class="table table-fixed w-100">
									<thead>
										<tr>
											<th class="header">Discontinue</th>
											<th class="header">Vendor</th>
											<th class="header">Item</th>
											<th class="header text-center">Committed</th>
											<th class="header text-center">OnOrder</th>
											<th class="header text-center">Avail</th>
											<th class="header">QOH</th>
											<th class="header">MIN</th>
											<th class="header">MAX</th>
											<th class="header text-right">Total Available</th>
											<th class="header text-right">Order Qty</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let item of watch_items">
											<td class="text-center">
												<mat-checkbox [(ngModel)]="item.watchlist"></mat-checkbox>
											</td>
											<td>
												<button class="mb-0 pt-0 pb-0 " mat-icon-button color="warn" (click)="viewPurchData(item)">
													<mat-icon>settings</mat-icon>
												</button>
												{{ item.vendor }}
											</td>
											<!--<td (click)="getItemHistory(item)"> {{ item.stockid }}</td>-->
											<td><b>{{ item.brand_data.brand }}</b><br>{{ item.stockid }}<br />
												{{ item.description }}
											</td>
											<td class="text-center">{{ item.qos }}</td>
											<td class="text-center">{{ item.qop }}</td>
											<td class="text-center">{{ ( item.qoh + item.qop ) - item.qos }}</td>
											<td class="text-center">{{ item.qoh }}</td>
											<td class="text-center">{{ item.minimum }}</td>
											<td class="text-center">{{ item.maximum }}</td>
											<td class="text-right">
												{{ item.total_remote_stock }}
											</td>
											<td class="text-right bolder">
												{{ item.target_purchase }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</ng-container>
					</mat-tab>
				</mat-tab-group>
			</ng-container>
		</ng-container>
	</div>
</div>